import React from "react";
import { Container, Nav, Navbar, Stack } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";
import { useTranslation } from 'react-i18next';
import "./SubNavigation.css";

function SubNavigationLocationManager() {
  const { t } = useTranslation();

  return (

    <div className="bg-light border my-2">
      <Nav fill variant="pills">
        <LinkContainer to="/accesslog" className="nav-link me-5" style={{ cursor: 'pointer' }}>
          <strong>관리자접근 사실기록조회</strong>
        </LinkContainer>
        <LinkContainer to="/accesslocation" className="nav-link mx-5" style={{ cursor: 'pointer' }}>
          <strong>위치정보 이용/제공 대장</strong>
        </LinkContainer>
      </Nav>
    </div>

  );
}

export default SubNavigationLocationManager;